import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createTheme, MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import { ModalsProvider } from "@mantine/modals";
import { RouterProvider } from "react-router";
import { routes } from "./routes.tsx";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: 15000,
    },
  },
});

const theme = createTheme({
  primaryColor: "gold",
  colors: {
    gold: [
      "#e2ba70",
      "#e2ba70",
      "#e2ba70",
      "#e2ba70",
      "#e2ba70",
      "#e2ba70",
      "#e2ba70",
      "#e2ba70",
      "#e2ba70",
      "#e2ba70",
    ],
  },
  headings: {
    textWrap: "balance",
    sizes: {},
  },
  autoContrast: true,
  defaultRadius: 0,
  respectReducedMotion: true,
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <ModalsProvider>
          <RouterProvider router={routes} />
          <ReactQueryDevtools initialIsOpen={false} />
        </ModalsProvider>
      </MantineProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
